import overArg from './_overArg.js';

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

export default getPrototype;



//////////////////
// WEBPACK FOOTER
// ./~/react-redux/~/lodash-es/_getPrototype.js
// module id = 224
// module chunks = 0